import { field, hidden } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";

@model("SizeTableEntry")
export default class SizeTableEntry {
	@field("number")
	public ID:number = 0;

	@field("number")
	@hidden()
	public SizeTableID:number = 0;

	@field("string")
	public Name:string = "";

	@field("number")
	public DisplayOrder:number = 0;

	// Transient client-side key for stable v-for keys in sortable lists. Not persisted.
	public clientKey:string = "";

	public constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID;
		this.SizeTableID = data.SizeTableID;
		this.Name = data.Name;
		this.DisplayOrder = data.DisplayOrder;
	}

	public getJSON(this:SizeTableEntry) {
		return {
			ID: this.ID,
			SizeTableID: this.SizeTableID,
			Name: this.Name,
			DisplayOrder: this.DisplayOrder
		};
	}
}
